import React, { useEffect, useState } from 'react';
import { Modal, Button, Row, Col, Form, FormGroup } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import { Heading5, Icon, Validator } from '../widgets';
import { GEO_FIELD_TYPE } from '../../constants';
import { saveBulkEditRegion, getGeoRegionList, getGeoCropList } from '../../actions/geo';
import { FormValidator } from '../../helpers/form-validator';

const BulkEditModal = props => {
    const { actions, farmId, onHide, selectedRegionIds, fieldType } = props;
    const [isSaving, setIsSaving] = useState(false);
    const [selectedFieldType, setFieldType] = useState(null);
    const [cropInfo, setCropInfo] = useState({
        id: null,
        name: ""
    });
    const [submitted, setSubmitted] = useState(false);
    const [isRegionSelect, setIsRegionSelect] = useState(fieldType.id !== 6);

    const cropList = useSelector(state => state.geo.cropList);

    useEffect(() => {
        actions.getGeoCropList({ farm_uuid: farmId });
    }, []);

    const isSelect = (value) => { return (value === null) || (value === ""); };

    const validator = new FormValidator([{
        field: 'selectedFieldType',
        method: isSelect,
        validWhen: false,
        message: 'Region type is required'
    }]);

    const [validation, setValidation] = useState(validator.valid());

    const handleSelect = selectedOption => {
        const { value, label } = selectedOption ? selectedOption : { value: 0, label: '' };
        setCropInfo({ ...cropInfo, name: label, id: value });
    };

    const handleOnBlur = (e) => {
        if (e.target.value > 0)
            setCropInfo({ ...cropInfo, name: e.target.value });
    };

    const handleInputChange = (value, event) => {
        if (event.action !== "input-blur" && event.action !== "menu-close") {
            setCropInfo({ ...cropInfo, id: value, name: value });
        }
    };

    const handleSave = () => {
        const validationValue = validator.validate({ selectedFieldType, validation });
        setValidation(validationValue && isRegionSelect);
        setSubmitted(true);

        if (validationValue.isValid || !isRegionSelect) {
            const params = {
                geo_region_uuid: selectedRegionIds,
                geo_region_type_id: selectedFieldType,
                crop_name: cropInfo.name ? cropInfo.name : null
            };

            const onSuccess = (isSuccess) => {
                if (isSuccess) {
                    actions.getGeoRegionList(farmId, true);
                    setIsSaving(false);
                    onHide();
                }
            };

            setIsSaving(true);
            actions.saveBulkEditRegion(params, onSuccess);
        }
    }

    const v = submitted ? validator.validate({ selectedFieldType, validation }) : validation;

    return <Modal show={true} backdrop="static" onHide={onHide} size='md'>
        <Modal.Header closeButton style={{ color: '#064d9e' }}>
            <Modal.Title >
                <Heading5>
                    Edit Place
                </Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {fieldType.id !== 6 &&
                <FormGroup>
                    <Form.Label>Region Type</Form.Label>
                    <Row className="justify-content-center">
                        <Col lg={4} md={4} sm={4} className="mt-1 ml-2 p-0">
                            <>
                                <Form.Check
                                    type="checkbox"
                                    name="regionType" value={true}
                                    inline
                                    id="regiontype"
                                    checked={isRegionSelect}
                                    onChange={e => setIsRegionSelect(e.target.checked)}
                                    style={{ marginRight: "6px" }} />
                                {fieldType.label}
                                <i className="fa fa-long-arrow-right i-arrow mt-2 ml-4" aria-hidden="true" />
                            </>
                        </Col>
                        <Col className="p-0" lg={7} md={7} sm={7}>
                            <Validator validation={v.selectedFieldType}>
                                <Form.Select
                                    id="type"
                                    placeholder="Choose a type"
                                    name="selectedFieldType"
                                    value={selectedFieldType}
                                    onChange={(e) => setFieldType(e ? e.value : null)}
                                    disabled={!isRegionSelect}
                                    style={{ width: "331px" }}
                                    options={GEO_FIELD_TYPE.filter(item => fieldType.regionTypeIds && fieldType.regionTypeIds.indexOf(item.id) < 0).map(e => ({ value: e.id, label: e.name }))}
                                    sortType="asc" />
                                {isRegionSelect && <Validator.Text />}
                            </Validator>
                        </Col>
                    </Row>
                </FormGroup>}
            <Row className="mt-3">
                <FormGroup>
                    <Form.Label style={{ marginLeft: "15px" }}>Crop</Form.Label>
                    <Row style={{ marginLeft: "0px", width: "495px" }}>
                        <Col>
                            <Form.Select
                                id="type"
                                placeholder="Choose a type"
                                name="selectedFieldType"
                                value={cropInfo.name}
                                onChange={(e) => handleSelect(e)}
                                onBlur={handleOnBlur}
                                noOptionsMessage={() => 'Create new crop'}
                                onInputChange={handleInputChange}
                                inputValue={cropInfo.name}
                                options={cropList.map(crop => { return { value: crop, label: crop } })}
                                sortType="asc" />
                        </Col>
                    </Row>
                </FormGroup>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant='btn btn-danger btn-sm' onClick={onHide} ><i className="fa fa-times-circle"></i> Cancel</Button>
            <Button variant='btn  btn-primary btn-sm'
                style={{ cursor: cropInfo.name === "" && selectedFieldType === null ? "not-allowed" : "pointer" }}
                onClick={handleSave}
                disabled={cropInfo.name === "" && selectedFieldType === null} ><Icon className="fa fa-floppy-o"></Icon>{isSaving ? " Saving..." : " Save"}</Button>
        </Modal.Footer>
    </Modal>
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ saveBulkEditRegion, getGeoRegionList, getGeoCropList }, dispatch)
});

export default connect(null, mapDispatchToProps)(BulkEditModal);